// ANCHOR Base
import { Block } from 'baseui/block';
import { HeadingMedium, LabelMedium } from 'baseui/typography';

// ANCHOR Models
import {
  useFormSubmissionDetailsItemData,
} from '@lyon/scoped-models/answer/FormSubmissionDetailsItem';
import { useFormData } from '@lyon/scoped-models/form/FormData';

// ANCHOR Utils
import { formatOrdinalLabel } from '@lyon/utils/extras/formatOrdinalLabel';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';

// ANCHOR Styles
import {
  SCORE, BLOCK, HEADING, INNER,
} from './styles';

export const LyonViewAnswerFormDetails = constant(() => {
  const formSubmission = useFormSubmissionDetailsItemData();
  const form = useFormData();

  if (!formSubmission || !form) {
    return <Loader />;
  }

  const studentScore = formSubmission.finalTotalScore
    ?? formSubmission.initialTotalScore
    ?? 0;
  const totalScorePossible = formSubmission.totalPossiblePoints;
  const showAfterRegrade = form.showAfterRegrade
    ? formSubmission.finalTotalScore != null
    : true;

  // TODO Add rank percentile logic
  const rankPercentile = undefined;

  return (
    <Block overrides={BLOCK}>
      <Block overrides={INNER}>
        <HeadingMedium overrides={HEADING}>
          {form.title}
        </HeadingMedium>
        {
          form.showScore && showAfterRegrade && (
            <Block display="flex" justifyContent="flex-end">
              <HeadingMedium overrides={SCORE}>
                {`${studentScore}/${totalScorePossible}`}
              </HeadingMedium>
            </Block>
          )
        }
      </Block>
      <LabelMedium>
        {`This is your ${formatOrdinalLabel(formSubmission.attempt)} take.`}
      </LabelMedium>
      {
        form.showRankPercentile && !form.showAfterRegrade && rankPercentile && (
          <LabelMedium marginTop="4px">
            You are in the top 95%
          </LabelMedium>
        )
      }
    </Block>
  );
});
